import React, { useRef } from "react";

import {
  Box,
  Typography,
  styled,
  TextField,
  FormHelperText,
  Button,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import GoalVideoUpload from "../GoalVideoUpload";
import UploadVideo from "./UploadVideo";
import GoalImageUpload from "./GoalImageUpload";
import { toast } from "react-toastify";
import { useAuth } from "../../../../context/auth";

const CustomTextarea = styled(TextField)(() => ({
  width: "100%",
  "& .MuiOutlinedInput-root": {
    backgroundColor: "transparent",
    border: "1px solid #e5e7eb",
    borderRadius: "8px",
    color: "black",
    padding: "10px 15px",
    "&:hover": {
      backgroundColor: "transparent",
      border: "1px solid #e5e7eb",
    },
    "&.Mui-focused": {
      backgroundColor: "transparent",
      border: "1px solid #e5e7eb",
      outline: "none",
    },
  },

  "& .MuiInputBase-input": {
    padding: "0",
  },

  "& .MuiOutlinedInput-notchedOutline": {
    border: "none",
    "&:hover": {
      border: "none",
    },
  },
}));

const Form = ({ data, setGoalVideos, index, setDeletedVideos, goalVideos }) => {
  const mounted = useRef(false);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Box className="goal-seperate-form">
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: "20px",
          }}
        >
          <Box className="category form-control">
            <Typography className="label">Club Name</Typography>
            <CustomTextarea
              variant="outlined"
              name="club_name"
              value={goalVideos[index].club_name}
              onChange={(e) => {
                setGoalVideos((prev) =>
                  prev.map((p, i) =>
                    i == index
                      ? { ...p, club_name: e.target.value, edited: true }
                      : { ...p }
                  )
                );
              }}
              placeholder="Enter club name"
            />
            {!goalVideos[index].club_name ? (
              <FormHelperText sx={{ color: "red" }}>
                Please enter the club name!
              </FormHelperText>
            ) : (
              ""
            )}
          </Box>
          <Box className="category form-control">
            <Typography className="label">Goal Scorer</Typography>
            <CustomTextarea
              variant="outlined"
              name="goal_scorer"
              value={goalVideos[index].goal_scorer}
              onChange={(e) => {
                setGoalVideos((prev) =>
                  prev.map((p, i) =>
                    i == index
                      ? { ...p, goal_scorer: e.target.value, edited: true }
                      : { ...p }
                  )
                );
              }}
              placeholder="Enter goal scorer"
            />
            {!goalVideos[index].goal_scorer ? (
              <FormHelperText sx={{ color: "red" }}>
                Please enter the goal scorer!
              </FormHelperText>
            ) : (
              ""
            )}
          </Box>
        </Box>

        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap",
            gap: "20px",
          }}
        >
          {/* Goal Image Upload */}
          <Box className="category form-control">
            <GoalImageUpload
              goalVideos={goalVideos}
              setGoalVideos={setGoalVideos}
              index={index}
            />

            {!goalVideos[index].goal_image && (
              <FormHelperText sx={{ color: "red" }}>
                Please upload Goal Image!
              </FormHelperText>
            )}
          </Box>

          {/* Goal Video Upload */}
          <Box className="category form-control" sx={{ marginRight: "50px" }}>
            <UploadVideo
              setGoalVideos={setGoalVideos}
              index={index}
              goalVideos={goalVideos}
            />

            {!goalVideos[index].goal && (
              <FormHelperText sx={{ color: "red" }}>
                Please enter the Goal Video!
              </FormHelperText>
            )}
          </Box>

          {/* Remove Button */}
          <Box sx={{ display: "flex", gap: "5px" }}>
            <Box></Box>
            <Box>
              <Button
                style={{
                  border: "1px solid #e5e7eb",
                  borderRadius: "8px",
                  color: "#ef364e",
                  padding: "8px 13px",
                  marginTop: "20px",
                }}
                onClick={() => {
                  if (goalVideos.length <= 1) {
                    toast.error(
                      "Please enter at least on Internation Tournament video."
                    );
                    return;
                  }
                  goalVideos.map((goal, i) => {
                    if (i == index && goal.id) {
                      setDeletedVideos((del) => [...del, goal.id]);
                    }
                  });
                  setGoalVideos((prev) =>
                    prev.filter((state, i) => {
                      if (i == index) {
                        return false;
                      } else {
                        return true;
                      }
                    })
                  );
                }}
              >
                Remove
              </Button>
            </Box>
          </Box>
        </Box>
      </Box>

      {data?.error && (
        <Box sx={{ width: "100%" }}>
          <FormHelperText sx={{ color: "red" }}>{data.error}</FormHelperText>
        </Box>
      )}
    </Box>
  );
};

export default Form;
